export enum PatientPrescriptionsType {
  LMDPrescription = 'lmd_prescription',
  Order = 'order',
  Prescription = 'prescription'
}

export enum PaymentStatus {
  Failed = 'failed',
  Paid = 'paid'
}

export enum PaymentStatusLabel {
  Failed = 'Waiting for payment',
  Paid = 'Paid'
}

export enum PrescriptionAcceptanceStatus {
  Canceled = 'canceled',
  Expired = 'expired',
  Paid = 'paid',
  PendingAcceptance = 'pending_acceptance'
}

export enum DevelopHealthPrescriptionDoseForm {
  CAPSULE = 'capsule',
  CONCENTRATE = 'concentrate',
  CREAM = 'cream',
  GEL = 'gel',
  INHALER = 'inhaler',
  INJECTABLE = 'injectable',
  LIQUID = 'liquid',
  LOZENGE = 'lozenge',
  OINTMENT = 'ointment',
  PATCH = 'patch',
  POWDER = 'powder',
  SOLUTION = 'solution',
  SUPPOSITORY = 'suppository',
  SUSPENSION = 'suspension',
  TABLET = 'tablet'
}

export enum DevelopHealthPrescriptionDispenseUnit {
  APPLICATOR = 'applicator',
  CAPSULE = 'capsule',
  GRAM = 'gram',
  INHALER = 'inhaler',
  LITER = 'liter',
  MICROGRAM = 'microgram',
  MILLIGRAM = 'milligram',
  MILLILITER = 'milliliter',
  PACK = 'pack',
  PATCH = 'patch',
  TABLET = 'tablet',
  UNIT = 'unit',
  VIAL = 'vial'
}

export enum LAST_DOSE_TAKEN {
  FOUR_PLUS_WEEKS = 'four-plus-weeks',
  LESS_THAN_ONE_WEEK = 'less-than-one-week',
  ONE_TO_THREE_WEEKS = 'one-to-three-weeks'
}

export enum DevelopHealthPrescriptionRouteOfAdministration {
  INHALATION = 'inhalation',
  INTRAMUSCULAR = 'intramuscular',
  INTRAVENOUS = 'intravenous',
  NASAL = 'nasal',
  OPHTHALMIC = 'ophthalmic',
  ORAL = 'oral',
  OTIC = 'otic',
  RECTAL = 'rectal',
  SUBCUTANEOUS = 'subcutaneous',
  TOPICAL = 'topical',
  VAGINAL = 'vaginal'
}

export const GLP_1_AND_KIT_GROUPED_ORDER = 'GLP-1 & kit';
